module.exports = __webpack_public_path__ + "img/LeanLarder3030.9a58fd91.png";